import React, { useEffect, useState, useRef } from 'react';
import Select from "react-select";
import makeAnimated from "react-select/lib/animated";
import { urlObtenerOpciones } from '../../constants/urls';

const SelectC = ({
  id,
  value,
  valueSelect,
  placeholder,
  onChange,
  mensajeError,
  isSearchable,
  peticiones,
  valorPadre,
  esDependiente,
  codPadre,
  validate,
  hasError,
  validationCallback,
  values,
  setLoading,
  isMulti,
  valorDependiente,
  required,
  esBloqueante,
  errorBloqueante,
  disabled,
  validacionYup,
  mensajeErrorYup
}) => {

  const [options, setOptions] = useState([]);
  const prevValorPadreRef = useRef(valorPadre);

  const esFlujoMotos = (peticiones && peticiones.url && peticiones.url.indexOf('motos=true') !== -1) ||
                       (typeof window !== 'undefined' && window.location && window.location.pathname.indexOf('/motos') !== -1);

  useEffect(() => {
    if (peticiones != null) {
      if (!esDependiente) {
        obtenerOpciones()
      }
    }
  }, [])

  useEffect(() => {
    if (valueSelect) {
      const opcionSeleccionada = options.find(option => option.label == valueSelect)

      const opcionSeleccionadaSelect = Array.isArray(values) ? values.find(option => option.value == valueSelect.value) : null

      if (opcionSeleccionadaSelect) {
        onChange(opcionSeleccionadaSelect)
        if (validationCallback) validationCallback(false)
      }

      if (opcionSeleccionada) {
        onChange(opcionSeleccionada)
        if (validationCallback) validationCallback(false)
      }

      if (opcionSeleccionada && opcionSeleccionada.esBloqueante == 'NO') {
        onChange(opcionSeleccionada)
        if (validationCallback) validationCallback(false)
      }
    }
  }, [valueSelect])

  useEffect(() => {
    if (values) {
      setOptions(values)
    }
  }, [values])

  useEffect(() => {
    if (peticiones != null && esDependiente) {
      if (esFlujoMotos) {
        const valPadreActual = (typeof valorPadre === 'object' && valorPadre !== null) ? valorPadre.value : valorPadre;
        const valPadrePrevio = (typeof prevValorPadreRef.current === 'object' && prevValorPadreRef.current !== null) ? prevValorPadreRef.current.value : prevValorPadreRef.current;

        // Si existía un valor del padre previamente y cambió con respecto al actual (ej: cambio de marca o deselección)
        if (valPadrePrevio && String(valPadreActual || '') !== String(valPadrePrevio || '')) {
          setOptions([]);
          if (onChange) {
            onChange(null);
          }
          if (validationCallback) {
            validationCallback(true);
          }
        }
        prevValorPadreRef.current = valorPadre;
      }

      obtenerOpciones();
    }

    if (values) {
      setOptions(values);
    }
  }, [esDependiente, valorPadre]);

  const obtenerOpciones = async () => {
    if (setLoading) setLoading(true);

    let url = `${urlObtenerOpciones}${peticiones.url}`;
    let body = peticiones.metodo == 'POST' ? JSON.stringify(peticiones.body) : null;

    if (esDependiente) {
      const valPadre = (typeof valorPadre === 'object' && valorPadre !== null) ? valorPadre.value : valorPadre;

      if (!valPadre) {
        setOptions([]);
        if (esFlujoMotos && value && onChange) {
          onChange(null);
          if (validationCallback) validationCallback(true);
        }
        if (setLoading) setLoading(false);
        return;
      }

      if (peticiones.metodo == 'POST') {
        body = body.replace("$" + codPadre, valPadre);
      }

      if (peticiones.metodo == 'GET') {
        if (codPadre && valPadre) {
          url = url.replace("$" + codPadre, valPadre);
        }
      }
    }

    try {
      const response = await fetch(url, { method: peticiones.metodo, body: body });
      const json = await response.json();

      if (esFlujoMotos) {
        const esTransaccionExitosa = json && json.transaccion !== false && !json.errorCodigo && response.ok !== false;

        if (esTransaccionExitosa) {
          let aux = [];
          const atributo = peticiones.atributo;
          const partes = atributo ? atributo.split(".") : [];
          let objetoActual = json;

          for (const parte of partes) {
            objetoActual = objetoActual[parte];
            if (objetoActual === undefined || objetoActual === null) {
              break;
            }
          }

          let opciones = objetoActual;

          if (Array.isArray(opciones) && opciones.length > 0) {
            opciones.forEach(p => {
              aux.push({ ...p, value: p[peticiones.value], label: p[peticiones.label] });
            });
            setOptions(aux);
          } else {
            // Sin modelos encontrados para esta marca en motos
            setOptions([]);
            if (onChange) {
              onChange(null);
              if (validationCallback) validationCallback(true);
            }
          }
        } else {
          // El WS devolvió error o transaccion: false en motos
          setOptions([]);
          if (onChange) {
            onChange(null);
            if (validationCallback) validationCallback(true);
          }
        }
      } else {
        // Flujo original sin alterar para otros productos
        if (json) {
          let aux = [];
          const atributo = peticiones.atributo;
          const partes = atributo ? atributo.split(".") : [];
          let objetoActual = json;

          for (const parte of partes) {
            objetoActual = objetoActual[parte];
            if (objetoActual === undefined || objetoActual === null) {
              break;
            }
          }

          let opciones = objetoActual;
          if (opciones) {
            opciones.forEach(p => {
              aux.push({ ...p, value: p[peticiones.value], label: p[peticiones.label] });
            });
            setOptions(aux);
          }
        }
      }
    } catch (error) {
      if (esFlujoMotos) {
        setOptions([]);
        if (onChange) {
          onChange(null);
          if (validationCallback) validationCallback(true);
        }
      }
    }

    if (setLoading) setLoading(false);
  };

  return (
    <div title={"select"}>
      {options.length > -1 &&
        <Select
          id={id}
          key={id}
          value={(value && (value.value !== undefined || value.label !== undefined)) ? value : null}
          components={makeAnimated()}
          isDisabled={(!valorDependiente ? false : (valorDependiente != valorPadre)) || disabled}
          onChange={(valor, e) => {
            onChange(valor)

            if (valor && valor.esBloqueante == 'SI') {
              if (validationCallback) validationCallback(true);
            } else if (isMulti && (!valor || valor.length == 0)) {
              if (validationCallback) validationCallback(true);
            } else if (esFlujoMotos && !valor && required) {
              if (validationCallback) validationCallback(true);
            } else {
              if (validationCallback) validationCallback(false);
            }
          }}
          options={options}
          isSearchable={isSearchable}
          placeholder={placeholder || "Seleccione..."}
          isMulti={isMulti}
          noOptionsMessage={esFlujoMotos ? (() => "No se encontraron opciones") : undefined}
        />
      }

      {
        (!validacionYup && esBloqueante) ?
          <div className="react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp">{errorBloqueante}</div> : null
      }
      {
        (!validacionYup && required && hasError && !esBloqueante) ?
          <div className="react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp">{mensajeError || 'El campo es requerido'}</div> : null
      }

      {validacionYup &&
        <label className='react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp'>
          {mensajeErrorYup}
        </label>
      }
    </div>
  );
};

export default SelectC;
